import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import CircleNotificationsSharpIcon from '@mui/icons-material/CircleNotificationsSharp';
import { IconButton, Badge, MenuItem, Box } from '@mui/material';
import moment from 'moment/moment';
import { StyledButton } from 'app/components/v2';
import { StyledMenu } from './style';
import { pushID } from 'app/store/features/notificationSlice';
// import apiService from 'app/services/apiService';
import { getAllMessages } from 'app/store/features/notificationsSlice';
import { ColorsV2 } from 'app/constants/color';

export default function NotificationDropdown() {
  const location = useLocation();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [messageList, setMessageList] = useState([]);
  const storeNotifications = useSelector(state => state.notifications.messages);
  const isDataFetched = useSelector(state => state.notifications.isDataFetched);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = () => {
    setAnchorEl(null);
    navigate('/messages');
  };

  const fetchData = useCallback(() => {
    if (!isDataFetched) dispatch(getAllMessages());
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const filteredUnReadMessages = storeNotifications?.filter(items => items.read !== true);
    setMessageList(filteredUnReadMessages);
  }, [storeNotifications]);

  const formatTime = array => {
    const formattedTimeArray = array?.map(item => ({
      ...item,
      time: moment(item.time, 'YYY-MM-DD h:mm:ss A').format('DD MMM YY HH:mm'),
    }));
    return formattedTimeArray;
  };
  const formatedArray = formatTime(messageList);
  const { t } = useTranslation('translation', { keyPrefix: 'notification_popup' });
  const handleNavigate = id => {
    navigate('/messages', { state: id });
    if (location.pathname === '/messages') {
      dispatch(pushID(id));
    }

    setAnchorEl(null);
    setMessageList(messageList.filter(item => item.id !== id));
  };
  return (
    <div>
      <IconButton
        id='demo-customized-button'
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{ padding: '10px', height: '1.5em', width: '1.5em' }}
        disableRipple
      >
        {messageList?.length ? (
          <Badge color='error' overlap='circular' badgeContent=' ' variant='dot'>
            {/* <img src='/assets/images/bell.svg' style={{ height: '26px', width: '26px' }} /> */}
            <CircleNotificationsSharpIcon style={{ color: 'white', fontSize: '1.1em' }} />
          </Badge>
        ) : (
          // <img src='/assets/images/bell.svg' style={{ height: '26px', width: '26px' }} />
          <CircleNotificationsSharpIcon style={{ color: 'white', fontSize: '1.1em' }} />
        )}
      </IconButton>
      <StyledMenu
        id='demo-customized-menu'
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          '& .MuiPaper-root': {
            marginTop: '8px',
            minWidth: '10vw',
            color: 'white',
            backgroundColor: ColorsV2.secondary,
            borderRadius: '8px',
            boxShadow:
              'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
            '& .MuiMenu-list': {
              padding: '1px 0',
            },
            '& .MuiMenuItem-root': {
              '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: 'black',
                borderRadius: 10,
                background: '#D3D3D3',
              },
            },
          },
        }}
      >
        {formatedArray?.slice(0, 3).map(items => (
          <MenuItem
            value={items.id}
            key={items.id}
            sx={{
              margin: '8px',
              textAlign: 'centre',
              borderRadius: '5px',
              height: '2.5em',
              fontSize: '0.7em',
              '&:hover': {
                backgroundColor: ColorsV2.acent,
              },
            }}
            onClick={() => handleNavigate(items.id)}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <Box
                sx={{
                  fontWeight: 500,
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  width: '200px',
                  marginRight: '15px',
                }}
              >
                {items.header}
              </Box>
              <Box sx={{ fontWeight: 300 }}>{items.time}</Box>
            </Box>
          </MenuItem>
        ))}
        {!formatedArray?.length && (
          <Box sx={{ fontWeight: 300, padding: '20px', textAlign: 'center', fontFamily: 'Roboto' }}>
            {t('alert')}
          </Box>
        )}
        <StyledButton
          name='IconButton'
          sx={{
            alignSelf: 'center',
            margin: '0 10px 10px 10px',
            width: '90%',
          }}
          onClick={handleMenuClick}
        >
          {t('messages')}
        </StyledButton>
      </StyledMenu>
    </div>
  );
}
